import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';
import css from 'css';

import { gtmPush, msg } from 'helpers';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutTimeSchedulerAutumnVariants,
    setCheckoutTimeSchedulerSpringVariants,
    setCheckoutAutumnTimeScheduleSlots,
    setCheckoutSpringTimeScheduleSlots,
    resetCheckoutAutumnTimeScheduleSlots,
    resetCheckoutSpringTimeScheduleSlots,
    setCheckoutStep,
    setCheckoutError
}               from 'store';
import {cookie} from "../../helpers";

function TimeSchedule(props) {
    const [autumnVariantPrev, setAutumnVariantPrev]   = useState(null);
    const [autumnVariant, setAutumnVariant]           = useState(null);
    const [springVariantPrev, setSpringVariantPrev]   = useState(null);
    const [springVariant, setSpringVariant]           = useState(null);
    const [currentAutumnIndex, setCurrentAutumnIndex] = useState(0);
    const [currentSpringIndex, setCurrentSpringIndex] = useState(0);
    const [autumnURL, setAutumnURL]                   = useState(null);
    const [springURL, setSpringURL]                   = useState(null);
    const [autumnVariantSaved, setAutumnVariantSaved] = useState(false);
    const [springVariantSaved, setSpringVariantSaved] = useState(false);
    const [loaded, setLoaded]                         = useState(false);
    const [unsavedTabs, setUnsavedTabs]               = useState({ autumn: false, spring: false });
    const autumnTabRef = useRef(null);
    const springTabRef = useRef(null);

    useEffect(() => {
        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Timeplanlegger',
            'pageURI': '/checkout/timeplanlegger'
        });
    }, []);

    useEffect(() => {
        props.setCheckoutTitle('Velg din timeplan');
        props.setCheckoutSubtitle('Trykk neste for å bla deg gjennom mulige kombinasjoner og trykk "Lagre" for å registrere hvilken timeplan du er interessert i. Du kan se ulike semestre i øvre venstre hjørne. Merk at forkurs, labkurs, streaming og nettkurs ikke vil vises i timeplanen - du vil få informasjon om dette etter bestilling. Om du ønsker å endre timeplan kan du gjøre dette ved å kontakte en rådgiver etter fullført bestilling.');
        _onHandleTimeScheduleException();
        props.setCheckoutNextCallback(_onHandleNext.bind(this));
    }, [springVariantSaved, autumnVariantSaved, loaded, currentAutumnIndex, currentSpringIndex]);

    useEffect(() => {
        if (autumnVariant != null && autumnVariantPrev == null) {
            setAutumnVariantPrev(autumnVariant);
            _loadAutumnCookies();
        }
    }, [autumnVariant]);

    useEffect(() => {
        if (springVariant != null && springVariantPrev == null) {
            setSpringVariantPrev(springVariant);
            _loadSpringCookies();
        }
    }, [springVariant]);

    const _loadAutumnCookies = () => {
        if (cookie.get('shoppingCartTimeScheduleAutumn')) {
            const shoppingCartTimeScheduleAutumn = JSON.parse(cookie.get('shoppingCartTimeScheduleAutumn'));
            setAutumnURL(shoppingCartTimeScheduleAutumn.url);
            setCurrentAutumnIndex(shoppingCartTimeScheduleAutumn.index);
            _onHandleSubmitSchemaVariant(shoppingCartTimeScheduleAutumn.index, true, false);
        } else {
            _onHandleGenerateTimeEditLink(autumnVariant, 0, true);
        }
    }

    const _loadSpringCookies = () => {
        if (cookie.get('shoppingCartTimeScheduleSpring')) {
            const shoppingCartTimeScheduleSpring = JSON.parse(cookie.get('shoppingCartTimeScheduleSpring'));
            setSpringURL(shoppingCartTimeScheduleSpring.url);
            setCurrentSpringIndex(shoppingCartTimeScheduleSpring.index);
            _onHandleSubmitSchemaVariant(shoppingCartTimeScheduleSpring.index, false, false);
        } else {
            _onHandleGenerateTimeEditLink(springVariant, 0, false);
        }
    }

    const _onHandleTimeScheduleException = () => {
        if (loaded) return null;

        /**
         * Quick workaround to exclude programs and spesific courses from timeschedule
         * ToDo: Define in the CMS what to be excluded or not
         */
        if(props.opportunity.programs.length > 0) props.setCheckoutStep(1);
        const excludedDeliveryTypes = ['Stream', 'Forkurs'];
        const courseObjects         = props.opportunity.courses.filter(course => {
            return !excludedDeliveryTypes.includes(course.delivery) || excludedDeliveryTypes.includes(course.type);
        });
        if(!courseObjects.length > 0) props.setCheckoutStep(1);

        _onHandleSchemaVariantsFetching(courseObjects);
    }

    const _onHandleSchemaVariantsFetching = async (courseObjects) => {
        let data = courseObjects.map(({offeringId}) => ({offeringId}));
        await api.getTimeScheduler(data).then(response => {
            const {autumnSchemaVariants, springSchemaVariants} = response.data;
            /*
             * Every schema variation contains a courseOccasions object from SF, but if that does not contain any courseOccasions
             * then we consider it as an empty time schedule. If both schema is empty then no time schedule needs
             * to be saved, continue to next checkout step
             */
            // Check if both semesters have no valid schemas (empty arrays or schemas with empty courseOccasions)
            const hasValidAutumnSchema = autumnSchemaVariants.length > 0 && 
                autumnSchemaVariants[0] && 
                autumnSchemaVariants[0].courseOccasions && 
                autumnSchemaVariants[0].courseOccasions.length > 0;
                
            const hasValidSpringSchema = springSchemaVariants.length > 0 && 
                springSchemaVariants[0] && 
                springSchemaVariants[0].courseOccasions && 
                springSchemaVariants[0].courseOccasions.length > 0;

            if (!hasValidAutumnSchema && !hasValidSpringSchema) {
                console.warn('No valid time schedule found');
                props.setCheckoutStep(1);
            }

            setAutumnVariant(prevState => prevState = hasValidAutumnSchema ? autumnSchemaVariants : null);
            setSpringVariant(prevState => prevState = hasValidSpringSchema ? springSchemaVariants : null);

            if (cookie.get('shoppingCartTimeScheduleAutumn')) {
                setAutumnVariantSaved(true);
            } else {
                setAutumnVariantSaved(prevState => prevState = hasValidAutumnSchema ? false : true);
            }

            if (cookie.get('shoppingCartTimeScheduleSpring')) {
                setSpringVariantSaved(true);
            } else {
                setSpringVariantSaved(prevState => prevState = hasValidSpringSchema ? false : true);
            }

            setLoaded(prevState => prevState = true);
        });
    }

    const _onHandleNextSchemaVariant = (schema, isAutumnSemester) => {
        let index = 0;
        if (isAutumnSemester) {
            if (currentAutumnIndex + 1 !== schema.length) {
                index = currentAutumnIndex + 1;
            }
            setCurrentAutumnIndex(index);
            setAutumnVariantSaved(false);
        } else {
            if (currentSpringIndex + 1 !== schema.length) {
                index = currentSpringIndex + 1;
            }
            setCurrentSpringIndex(index);
            setSpringVariantSaved(false);
        }
        _onHandleGenerateTimeEditLink(schema, index, isAutumnSemester);
    }

    const _onHandlePreviousSchemaVariant = (schema, isAutumnSemester) => {
        let index = 0;
        if(isAutumnSemester) {
            setCurrentAutumnIndex(prevState => {
                if (prevState === 0) {
                    index = schema.length -1;
                } else {
                    index = prevState - 1;
                }
                return index;
            });
            setAutumnVariantSaved(false);
            _onHandleGenerateTimeEditLink(schema, index, isAutumnSemester);
        } else {
            setCurrentSpringIndex(prevState => {
                if (prevState === 0) {
                    index = schema.length -1;
                } else {
                    index = prevState - 1;
                }
                return index;
            });
            setSpringVariantSaved(false);
            _onHandleGenerateTimeEditLink(schema, index, isAutumnSemester);
        }
    }


    const _onHandleGenerateTimeEditLink = (schema, index, isAutumnSemester) => {
        if (schema === null || typeof schema === 'undefined' || typeof schema[index] === 'undefined' || !schema[index].courseOccasions.length > 0) return null;
        let url           = new URL('https://cloud.timeedit.net/bjor/web/student/s.html?');
        let search_params = url.searchParams;
        search_params.append('sid', 12);

        const schemaArray = schema[index].courseOccasions;

        schemaArray.forEach(item => {
            search_params.append('object', item.occasionId);
            search_params.append('type', 'courseevent');
        });

		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1;
		let year;

        if (isAutumnSemester) {
			if (currentMonth > 10) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}
            search_params.append('startdate', `${year}0817`);
            search_params.append('enddate', `${year}0823`);
        } else {
			if (currentMonth > 3) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}
            search_params.append('startdate', `${year}0118`);
            search_params.append('enddate', `${year}0124`);
        }

        search_params.append('p', '0.m%2C2.w');
        search_params.append('h', 'f');
        search_params.append('h2', '2');

        url.search = search_params.toString();

        if (isAutumnSemester) {
            setAutumnURL(url.toString());
        } else {
            setSpringURL(url.toString());
        }
    }

    const _addCookie = (index, isAutumnSemester) => {
        if (isAutumnSemester) {
            cookie.set('shoppingCartTimeScheduleAutumn', JSON.stringify({ url: autumnURL, index}), 1);
        } else {
            cookie.set('shoppingCartTimeScheduleSpring', JSON.stringify({ url: springURL, index}), 1);
        }
    }

    const _onHandleSubmitSchemaVariant = (index, isAutumnSemester = true, saveCookie=true) => {
        const schema = isAutumnSemester ? autumnVariant : springVariant;
        isAutumnSemester ? props.resetCheckoutAutumnTimeScheduleSlots() : props.resetCheckoutSpringTimeScheduleSlots();

        schema[index].courseOccasions.forEach(course => {
            isAutumnSemester ? props.setCheckoutAutumnTimeScheduleSlots(course.occasionId) : props.setCheckoutSpringTimeScheduleSlots(course.occasionId);
        });

        // Remove conflicts from the opposite semester
        if (autumnVariant && springVariant) {
            const oppositeSemesterSchema = isAutumnSemester ? springVariant : autumnVariant;
            const schemaConflicts        = schema[index].nonConflictingSchemaVariants;
            const newSchemaVariant       = oppositeSemesterSchema.filter(object => {
                return schemaConflicts.includes(object.variantId)
            });

            isAutumnSemester ? setSpringVariant(newSchemaVariant) : setAutumnVariant(newSchemaVariant);
        }

        if (isAutumnSemester) {
            setAutumnVariantSaved(true);
            setUnsavedTabs(prev => ({ ...prev, autumn: false }));
        } else {
            setSpringVariantSaved(true);
            setUnsavedTabs(prev => ({ ...prev, spring: false }));
        }

        _onHandleGenerateTimeEditLink(schema, index, isAutumnSemester);

        if (saveCookie) {
            _addCookie(index, isAutumnSemester);
        }
    }

    const _onHandleNext = () => {
        const autumnUnsaved = autumnVariant && !autumnVariantSaved;
        const springUnsaved = springVariant && !springVariantSaved;

        if (!autumnUnsaved && !springUnsaved) {
            setUnsavedTabs({ autumn: false, spring: false });
            return new Promise(resolve => resolve(true));
        }

        setUnsavedTabs({ autumn: autumnUnsaved, spring: springUnsaved });

        if (autumnUnsaved && springUnsaved) {
            props.setCheckoutError(
                `Du må lagre timeplan for både ${_msgFilter("scheduleTabAutumn")} og ${_msgFilter("scheduleTabSpring")} for å gå videre.`,
                false
            );
        } else if (autumnUnsaved) {
            props.setCheckoutError(
                `Du må lagre timeplan for ${_msgFilter("scheduleTabAutumn")} for å gå videre.`,
                false
            );
            if (autumnTabRef.current) autumnTabRef.current.click();
        } else {
            props.setCheckoutError(
                `Du må lagre timeplan for ${_msgFilter("scheduleTabSpring")} for å gå videre.`,
                false
            );
            if (springTabRef.current) springTabRef.current.click();
        }

        return false;
    }

    const _msgFilter = (msgKey) => {
        
        const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1;
		let year;
		let msgWP = msg(msgKey);

        if (msgKey === "scheduleTabAutumn") {
			if (currentMonth > 10) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}

            return msgWP.replace('%year%', year.toString().slice(-2));
        }
        
        if(msgKey === "scheduleTabSpring") {
			if (currentMonth > 3) {
				year = currentYear + 1;
			} else {
				year = currentYear;
			}

            return msgWP.replace('%year%', year.toString().slice(-2));
        }

        return msgWP;
    }

    return (
        <TabWrapper>
            <input ref={autumnTabRef} {...autumnVariant ? {defaultChecked: true} : {}} id="tab1" type="radio" name="tab" data-tab="tab1"/>
            <input ref={springTabRef} {...setSpringVariant ? {defaultChecked: true} : {}} id="tab2" type="radio" name="tab"
                   data-tab="tab2"/>
            <nav>
                { autumnVariant && (
                    <label htmlFor="tab1" data-tab-label="tab1" data-unsaved={unsavedTabs.autumn || undefined}>
                        {_msgFilter("scheduleTabAutumn")}
                    </label>
                )}
                { springVariant && (
                    <label htmlFor="tab2" data-tab-label="tab2" data-unsaved={unsavedTabs.spring || undefined}>
                        {_msgFilter("scheduleTabSpring")}
                    </label>
                )}
            </nav>
            <section data-tab-panel="tab1">
                <VariationWrapper>
                    <div class="number-input">
                        <button onClick={() => _onHandlePreviousSchemaVariant(autumnVariant, true)} class="minus"></button>
                        <input value={currentAutumnIndex + 1} type="number"/>
                        <button onClick={() => _onHandleNextSchemaVariant(autumnVariant, true)} class="plus"></button>
                    </div>
                    <SubmitButton id="autumnButton" onClick={() => _onHandleSubmitSchemaVariant(currentAutumnIndex, true)} disabled={autumnVariantSaved}>Lagre Timeplan</SubmitButton>
                </VariationWrapper>
                <iframe src={ autumnURL } width="100%" height="600px"></iframe>
            </section>
            <section data-tab-panel="tab2">
                <VariationWrapper>
                    <div class="number-input">
                        <button onClick={() => _onHandlePreviousSchemaVariant(springVariant, false)} class="minus"></button>
                        <input value={currentSpringIndex + 1} type="number"/>
                        <button onClick={() => _onHandleNextSchemaVariant(springVariant, false)} class="plus"></button>
                    </div>
                    <SubmitButton onClick={() => _onHandleSubmitSchemaVariant(currentSpringIndex, false)} disabled={springVariantSaved}>Lagre Timeplan</SubmitButton>
                </VariationWrapper>
                <iframe src={ springURL } width="100%" height="600px"></iframe>
            </section>
        </TabWrapper>
    )
}

const mapStateToProps = state => ({
    checkout    : state.checkout,
    opportunity : state.opportunity,
    timeSchedule: state.timeSchedule,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutTimeSchedulerAutumnVariants,
    setCheckoutTimeSchedulerSpringVariants,
    setCheckoutAutumnTimeScheduleSlots,
    setCheckoutSpringTimeScheduleSlots,
    resetCheckoutAutumnTimeScheduleSlots,
    resetCheckoutSpringTimeScheduleSlots,
    setCheckoutError,
    setCheckoutStep,
    setCheckoutNextCallback
}

export default connect(mapStateToProps, actions)(TimeSchedule);

const TabWrapper = styled.div`
    background-color: grey;
    
    [data-tab] {
        display: none;
    }
  
    [data-tab-panel] {
        opacity: 0;
        background-color: white;
        transition: opacity .3s ease-in-out;
        visibility: hidden;
        height: 0;
        position: relative;
        z-index: 1;
    }
  
    [data-tab-label] {
        padding: 1rem 1.5rem;
        display: inline-block;
        background-color: grey;
        cursor: pointer;
        position: relative;
        bottom: -1px;
    }
  
  
    [data-tab="tab1"]:checked ~ nav [data-tab-label="tab1"],
    [data-tab="tab2"]:checked ~ nav [data-tab-label="tab2"],
    [data-tab="tab3"]:checked ~ nav [data-tab-label="tab3"] {
        background-color: white;
        z-index: 10;
    }

  
    [data-tab="tab1"]:checked ~ nav ~ [data-tab-panel="tab1"],
    [data-tab="tab2"]:checked ~ nav ~ [data-tab-panel="tab2"],
    [data-tab="tab3"]:checked ~ nav ~ [data-tab-panel="tab3"] {
        opacity: 1;
        visibility: visible;
        padding: 1rem .5rem;
        border: 1px solid var(--tab-border-color);
        width: 100%;
        height: auto;
    }

    [data-tab-label][data-unsaved] {
        color: #d0021b;
    }

    [data-tab-label][data-unsaved]::after {
        content: ' ⚠';
        font-size: 0.85em;
    }
`;

const VariationWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    padding-bottom: 50px;

    input[type="number"] {
        -webkit-appearance: textfield;
        -moz-appearance: textfield;
        appearance: textfield;
    }
  
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
    }
  
    .number-input {
        border: 2px solid #ddd;
        display: inline-flex;
    }
  
    .number-input,
    .number-input * {
        box-sizing: border-box;
    }
    
    .number-input button {
        outline:none;
        -webkit-appearance: none;
        background-color: transparent;
        border: none;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        cursor: pointer;
        margin: 0;
        position: relative;
    }


    .number-input button.plus:after {
        content: '>';
        height: 2rem;
        width: 2rem;
    }
    .number-input button.minus:after {
        content: '<';
        height: 2rem;
        width: 2rem;
    }
  
    .number-input input[type=number] {
        font-family: sans-serif;
        max-width: 5rem;
        padding: .5rem;
        border: solid #ddd;
        border-width: 0 2px;
        font-size: 1rem;
        height: 2rem;
        font-weight: bold;
        text-align: center;
    }
`;

const SubmitButton = styled.button`
    position: relative;
    padding: 10px;
    background-color: ${css.colors.blue};
    color: #FFFFFF;
    margin-left: 25px;

    &[disabled] {
        background-color: grey;
        opacity: 0.7;
    }

    &:hover {
        cursor: pointer;
    }
`;


// WEBPACK FOOTER //
// ./src/partials/Checkout/TimeSchedule.js